/* Olie-rekenhulp: verbruik per maand, hoe lang elke fles meegaat en de prijs per maand.
   Met abonnementen: het plan dat bij het verbruik past, wordt aangeraden en voorgeselecteerd. */
(function () {
  var t = function (k, v) {
    var s = (window.T && window.T[k]) || '';
    if (v) { for (var x in v) { s = s.split('{' + x + '}').join(v[x]); } }
    return s;
  };
  var money = function (c) { return (window.TheWootz && window.TheWootz.money) ? window.TheWootz.money(c) : (c / 100).toFixed(2).replace('.', ','); };
  function duration(months) {
    if (months < 1) { var w = Math.max(1, Math.round(months * 4.3)); return w === 1 ? t('lasts_week_one') : t('lasts_weeks', { n: w }); }
    if (months < 2) return t('lasts_month');
    if (months >= 12) {
      var y = Math.floor(months / 12), rest = Math.round(months - y * 12);
      var jaren = y === 1 ? t('year_one') : t('years', { n: y });
      if (rest >= 2) return t('lasts_year_months', { jaren: jaren, n: rest });
      return y === 1 ? t('lasts_year_one') : t('lasts_years', { n: y });
    }
    return t('lasts_months', { n: Math.floor(months) });
  }
  document.querySelectorAll('[data-oilcalc]').forEach(function (root) {
    var mlPer = parseFloat(root.getAttribute('data-ml')) || 20;
    var input = root.querySelector('[data-oil-boards]');
    var freq = 2;
    var sub = root.querySelector('[data-oilsub]');
    var subPicked = false;

    // Plan dat bij het verbruik past: de kleinste levering per maand die het verbruik dekt (10% speling),
    // anders de grootste. Zolang iemand zelf niets koos, staat dat plan ook aangevinkt.
    function fitSub(perMonth) {
      if (!sub) return;
      var plans = Array.prototype.slice.call(sub.querySelectorAll('[data-sub-plan]'));
      var fit = null, most = null;
      plans.forEach(function (pl) {
        var months = parseFloat(pl.getAttribute('data-months')) || 0;
        pl._supply = months > 0 ? parseFloat(pl.getAttribute('data-ml')) / months : 0;
        if (!pl._supply) return;
        if (pl._supply >= perMonth * 0.9 && (!fit || pl._supply < fit._supply)) fit = pl;
        if (!most || pl._supply > most._supply) most = pl;
      });
      fit = fit || most || plans[0];
      plans.forEach(function (pl) {
        pl.querySelector('[data-sub-fit]').hidden = pl !== fit || !pl._supply;
        if (!subPicked) pl.setAttribute('aria-checked', pl === fit ? 'true' : 'false');
      });
    }

    if (sub) {
      sub.addEventListener('click', function (e) {
        var pl = e.target.closest('[data-sub-plan]');
        if (pl) {
          subPicked = true;
          sub.querySelectorAll('[data-sub-plan]').forEach(function (x) { x.setAttribute('aria-checked', x === pl ? 'true' : 'false'); });
          return;
        }
        var btn = e.target.closest('[data-sub-add]');
        if (!btn) return;
        var sel = sub.querySelector('[data-sub-plan][aria-checked="true"]') || sub.querySelector('[data-sub-plan]');
        var err = sub.querySelector('[data-sub-error]');
        var T = window.TheWootz || {};
        if (!sel || !T.addToCart) return;
        var label = btn.textContent;
        btn.disabled = true; btn.textContent = t('please_wait'); err.hidden = true;
        T.addToCart([{ id: parseInt(sel.getAttribute('data-variant'), 10), quantity: 1, selling_plan: parseInt(sel.getAttribute('data-sub-plan'), 10) }])
          .then(function () { btn.textContent = t('added'); setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1400); })
          .catch(function (e2) { btn.textContent = label; btn.disabled = false; err.textContent = e2.message || t('add_failed_retry'); err.hidden = false; });
      });
      sub.addEventListener('keydown', function (e) {
        if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
        var pl = e.target.closest('[data-sub-plan]');
        if (!pl) return;
        e.preventDefault();
        var list = Array.prototype.slice.call(sub.querySelectorAll('[data-sub-plan]'));
        var n = list[(list.indexOf(pl) + ((e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 1) + list.length) % list.length];
        n.click(); n.focus();
      });
    }

    function update() {
      var boards = Math.min(20, Math.max(1, parseInt(input.value, 10) || 1));
      input.value = boards;
      var perMonth = boards * mlPer * freq;
      var totaal = root.querySelector('[data-oil-total]');
      if (totaal) totaal.textContent = perMonth;
      root.querySelector('[data-oil-usage]').innerHTML = t('oil_usage_sum', { planken: boards === 1 ? t('oil_board_one') : t('oil_boards', { n: boards }), keer: freq, per: mlPer, ml: '<strong>' + perMonth + ' ml</strong>' });
      fitSub(perMonth);
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-oil-row]'));
      var best = null, advice = null;
      rows.forEach(function (row) {
        var ml = parseFloat(row.getAttribute('data-bottle')), price = parseInt(row.getAttribute('data-price'), 10);
        var months = ml / perMonth, pm = price / months;
        row._m = months; row._pm = pm;
        var beh = Math.floor(ml / mlPer);
        row.querySelector('[data-oil-months]').textContent = (beh === 1 ? t('oil_treatment_one', { ml: mlPer }) : t('oil_treatments', { n: beh, ml: mlPer })) + ' \u00b7 ' + duration(months);
        row.querySelector('[data-oil-permonth]').textContent = t('per_month', { bedrag: money(Math.round(pm)) });
        // Balkje: hoe lang de fles meegaat, vol is een jaar of langer.
        var balk = row.querySelector('[data-oil-bar]');
        if (balk) balk.style.width = Math.max(4, Math.min(100, months / 12 * 100)) + '%';
        if (!best || pm < best._pm) best = row;
        if (months >= 6 && (!advice || ml < parseFloat(advice.getAttribute('data-bottle')))) advice = row;
      });
      if (!advice) advice = rows.reduce(function (a, r) { return !a || r._m > a._m ? r : a; }, null);
      rows.forEach(function (row) {
        var badge = row.querySelector('[data-oil-badge]');
        var text = row === advice ? t('fits_best') : (row === best ? t('cheapest') : '');
        badge.textContent = text; badge.hidden = !text;
        row.classList.toggle('is-advice', row === advice);
      });
    }
    root.addEventListener('click', function (e) {
      var st = e.target.closest('[data-oil-step]');
      if (st) { input.value = (parseInt(input.value, 10) || 1) + parseInt(st.getAttribute('data-oil-step'), 10); update(); return; }
      var f = e.target.closest('[data-oil-freq]');
      if (f) {
        freq = parseInt(f.getAttribute('data-oil-freq'), 10);
        root.querySelectorAll('[data-oil-freq]').forEach(function (b) { b.setAttribute('aria-pressed', b === f ? 'true' : 'false'); });
        update();
      }
    });
    input.addEventListener('input', update);
    update();
  });
})();
